import ProtectedRoute from 'components/ProtectedRoute'
import useFlag from 'hooks/useFlag'
import useIsAdmin from 'hooks/useIsAdmin'
import React from 'react'
import { Switch } from 'react-router-dom'
import TermsAndPoliciesBuilder from 'scenes/Cms/Settings/TermsAndPolicies/TermsAndPoliciesBuilder'
import Landing from './components/Landing'
import AppNavigation from './Content/AppNavigation'

/** Top-level CMS section with routes for brand content, app navigation, and legal docs builder. */
const Cms: React.FC = () => {
  const isAdmin = useIsAdmin()
  const customizableLegalDocsFlag = useFlag('mx-customizable-legal-docs', false)
  const isCustomizableRoutesEnabled = customizableLegalDocsFlag && isAdmin

  return (
    <div className="full-height grey-05-bkg">
      <Switch>
        <ProtectedRoute
          redirect="/thanx_campaigns"
          resource="CMS"
          path="/brand_content/app_navigation"
          component={AppNavigation}
        />
        <ProtectedRoute
          redirect="/thanx_campaigns"
          resource="CMS"
          exact
          path="/brand_content"
          component={Landing}
        />
        {isCustomizableRoutesEnabled && (
          <ProtectedRoute
            redirect="/thanx_campaigns"
            resource="CMS"
            exact
            path="/brand_content/terms_and_policies_builder/:legal_doc_type"
            accessType="manage"
            component={TermsAndPoliciesBuilder}
          />
        )}
      </Switch>
    </div>
  )
}

export default Cms
